import React, { useContext, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { ToastContext } from '../../Context/WaToastContext';
import '../../styles-wa/toast.css';

const Toast = ({ message, type = 'error', onClose, duration = 3500 }) => {
    const { toasts, removeToast } = useContext(ToastContext);
    const hasInlineToast = typeof message === 'string' && message.length > 0;
    const visibleToasts = hasInlineToast
        ? [{ id: 'inline-toast', message, type }]
        : toasts;

    useEffect(() => {
        if (hasInlineToast && onClose) {
            const timer = setTimeout(() => {
                onClose();
            }, duration);
            return () => clearTimeout(timer);
        }
    }, [hasInlineToast, onClose, duration]);

    const handleClose = (toastId) => {
        if (hasInlineToast) {
            if (typeof onClose === 'function') {
                onClose();
            }
            return;
        }
        removeToast(toastId);
    };

    if (visibleToasts.length === 0) return null;

    return createPortal(
        <div className="toast-container">
            {visibleToasts.map((toast) => {
                const isDelete = toast.type === 'delete' || (typeof toast.message === 'string' && toast.message.toLowerCase().includes('delete'));
                const toastTypeClass = isDelete ? 'toast-delete' : `toast-${toast.type}`;
                return (
                    <div key={toast.id} className={`toast ${toastTypeClass}`}>
                        <div className="toast-content">
                            <span className="toast-message">{toast.message}</span>
                            <button type="button" className="toast-close" onClick={() => handleClose(toast.id)}>
                                ✕
                            </button>
                        </div>
                    </div>
                );
            })}
        </div>,
        document.body
    );
};

export default Toast;



